import SearchInput from "@/components/SearchInput";

type Props = {
  query: string;
  onChange: (value: string) => void;
  onClear: () => void;
};

/** Page-local Search People field for Member Elections. */
export default function MemberElectionsSearchInput({ query, onChange, onClear }: Props) {
  return (
    <SearchInput
      ariaLabel="Search People"
      placeholder="Search People"
      query={query}
      onChange={onChange}
      onClear={onClear}
    />
  );
}
